var searchApp = angular.module('searchApp', ['ngSanitize']);

searchApp.provider('swiftypePublicApi', function() {
  this.engineKey = null;
  this.apiHost = 'https://api.swiftype.com';
  this.apiBaseEndpoint = this.apiHost + '/api/v1/public/';

  this.$get = function($http) {
    var engineKey = this.engineKey;
    var apiBaseEndpoint = this.apiBaseEndpoint;

    return {
      apiEndpoint: function(endpoint) {
        return apiBaseEndpoint + endpoint;
      },
      search: function(query, options) {
        var params = $.param(angular.extend(options, {
          engine_key: engineKey,
          q: query,
          callback: 'JSON_CALLBACK'
        })),
        searchEndpoint = this.apiEndpoint('engines/search.json?' + params);
        return $http.jsonp(searchEndpoint);
      }
    };
  };

  this.setEngineKey = function(engineKey) {
    this.engineKey = engineKey;
  };
});

searchApp.controller('swiftypeSearchController', ['$scope', '$location', 'swiftypePublicApi', function($scope, $location, swiftypePublicApi) {

  // gets the value of a URL parameter by parameter name
  var getParameterByName = function(name) {
    // in the iframe we need to use the referrer since getting the window.top.location is a cross site request.
    var url = (window.location != window.parent.location) ? document.referrer: document.location;
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    results = regex.exec(url);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };
  
  
  // Query state
  $scope.stq = getParameterByName('stq');
  $scope.queryFilters = { shopify: {} };
  $scope.queryPerPage = 30;
  $scope.queryFacets = { shopify: ['tags'] };
  $scope.redirects = {
    "kdf-51ws520": "https://www.bulbamerica.com/collections/sony",
    "trak lighting": "https://www.bulbamerica.com/collections/track-lighting",
    "par36 gu10 120v 75w": "https://www.bulbamerica.com/collections/par36-bulbs",
    "sunlite am54 12-inch 2-bulb fluorescent": "https://www.bulbamerica.com/search#stq=am54&stp=1",
    "satco s9082": "https://www.bulbamerica.com/collections/par20-r20-led",
    "F15T8": "https://www.bulbamerica.com/search#stq=f15t8&stp=1",
    "S6511": "https://www.bulbamerica.com/search#stq=f15t8&stp=1",
    "F15T8/D": "https://www.bulbamerica.com/search#stq=f15t8&stp=1", 
    "F15 T8": "https://www.bulbamerica.com/search#stq=f15t8&stp=1",
    "18W F15 T8": "https://www.bulbamerica.com/search#stq=f15t8&stp=1",
    "Sylvania 21600": "https://www.bulbamerica.com/search#stq=f15t8&stp=1",
    "order number": "https://www.bulbamerica.com/account/login"
  };

  $scope.resultStyleOptions = ["grid", "list"];
  $scope.currentResultStyle = "grid";

  $scope.docTypes = ['shopify'];

  var stateAttributes = ['currentPage'];
  var currentState = $location.search();
  stateAttributes.forEach(function(key) {
    if (typeof currentState[key] !== 'undefined') {
      $scope[key] = currentState[key];
    }
  });
  
  if (typeof currentState['tags'] !== 'undefined') {
    $scope.urlFilters = { shopify: { tags: { type: "and", values: [] }}};
    $scope.urlFilters["shopify"]["tags"]["values"] = currentState['tags'].split(',');
  }

   $scope.saveCurrentState = function() {
     stateAttributes.forEach(function(key) {
       $location.search(key, $scope[key]);
     });


     if (typeof $scope.queryFilters["shopify"]["tags"] !== 'undefined'){
       $location.search("tags", $scope.queryFilters["shopify"]["tags"]["values"].join(","));
     }
  };
  
 

 $scope.colorHex = function(color){
   var colors = { "amber":"#FFC200",
      "antique gold": "#E5C100",
      "aqua": "#00FFFF",
      "aquamarine": "#7FFFD4",
      "azure": "#F0FFFF",
      "baby blue": "#89cff0",
      "beige": "#f5f5dc",
      "black": "#000000",
      "blue": "#0000ff",
      "blue green": "#0d98ba",
      "blue violet": "#2e2be2",
      "blue-green": "#0d98ba",
      "bronze": "#cd7f32",
      "brown": "#a52a2a",
      "brown-green": "#a5872a",
      "burgundy": "#800020",
      "burnt orange": "#cc5500",
      "burnt sienna": "#e97451",
      "burnt umber": "#8a3324",
      "champagne": "#fad6a5",
      "charcoal": "#36454f",
      "chartreuse": "#7fff00",
      "cherry blossom pink": "#ffb7c5",
      "chocolate": "#D2691E",
      "cobalt": "#0047ab",
      "copper": "#b87333",
      "coral": "#ff7f50",
      "cream": "#fffdd0",
      "cyan": "#00ffff",
      "dandelion": "#f0e130",
      "emerald": "#50c878",
      "flocked pink on pink": "#ffdae0",
      "forest green": "#228b22",
      "french rose": "#f64a8a",
      "fuchsia": "#ff00ff",
      "gold": "#ffd700",
      "green": "#00ff00",
      "grey": "#808080",
      "hot pink": "#ff69b4",
      "indigo": "#4b0082",
      "lavender": "#e6e6fa",
      "lemon": "#fff700",
      "lilac": "#c8a2c8",
      "lime": "#bfff00",
      "lime green": "#32cd32",
      "linen": "#faf0e6",
      "magenta": "#ff00ff",
      "maroon": "#800000",
      "mint green": "#98ff98",
      "misty rose": "#ffe4e1",
      "mocha": "#654634",
      "mustard": "#ffdb58",
      "navy blue": "#000080",
      "ochre": "#cc7722",
      "olive": "#808000",
      "orange": "#ffa500",
      "orchid": "#da70d6",
      "peach": "#ffe5b4",
      "pink": "#ffc0cb",
      "platinum": "#e5e4e2",
      "pumpkin": "#ff7518",
      "purple": "#800080",
      "red": "#ff0000",
      "rose": "#ff007f",
      "royal blue": "#4169e1",
      "royal purple": "#7851a9",
      "salmon": "#ff8c69",
      "sangria": "#92000A",
      "sapphire": "#0f52ba",
      "scarlet": "#ff2400",
      "sepia": "#704214",
      "silver": "#c0c0c0",
      "sky blue": "#87ceeb",
      "tan": "#d2b48c",
      "tangerine": "#f28500",
      "teal": "#008080",
      "turquoise": "#30d5c8",
      "violet": "#ee82ee",
      "yellow": "#ffff00" };

   return colors[color];
 };

  $scope.allowedFacets = { type: ["fluorescent-bulbs", "fluorescent-tube", "germicidal-bulbs", "led-bulbs", "halogen-bulbs", "hid-bulbs", "incandescent-bulbs", "miniature-bulbs", "led-strips", "projector-lamps", "christmas", "fixtures", "electrical", "stage-lighting", "bulb-accessories"], 
      itemtype: ["assorted-ornaments", "ball-ornament", "bell-ornament", "berry-branch", "berry-candle-ring", "berry-centerpiece", "berry-garland", "berry-pick", "berry-spray", "berry-teardrop", "birch-ornament", "bird-ornament", "bow", "candy-ornament", "centerpiece", "christmas-tree", "christmas-wreath", "curly-spray", "cut-drop-ornament", "diamond-finial-ornament", "diamond-ornament", "drop-ornament", "electrical-accessory", "electrical", "replacement-string", "feather-ornament", "finial-ornament", "flat-ball-ornament", "flower-pick", "garland", "garland-ornament", "glitter-spray", "grape-cluster-ornament", "icicle-garland", "icicle-light-strings", "icicle-ornament", "incandescent-light-strings", "led-light-strings", "kissing-ball-ornament", "lantern-ornament", "led-battery-light-set", "led-icicle-light-strings", "led-novelty-lights", "led-net-lights", "christmas-incandescent-bulbs", "christmas-led-bulbs", "c-shape-led", "led-replacement-bulbs", "led-rope-lights", "led-tear-drop-lights", "light-sphere", "light-string", "lighted-decor", "lighted-tree-topper", "mercury-ball-ornament", "net-lights", "novelty-lights", "onion-drop-ornament", "onion-ornament", "onion-ornament", "other-decor", "pick", "pine-ball-spray", "pinecone-ornament", "pinecone-ornament", "poinsettia-spray", "polka-dot-ball-ornament", "prelit-garland", "replacement-bulbs", "ribbon", "rope-lights", "sequin-spray", "skinny-drop-ornament", "snowflake-ornament", "snowman-ornament", "sparkle-spray", "spiral-drop-ornament", "spary", "spray", "spray-with-cones", "star-ornament", "swag", "swag-garland", "swirl-drop-ornament", "swirl-ornament", "tabletop", "teardrop", "teardrop-ornament", "tree-bag", "tree-stand", "twinkle-light-set", "vine", "wave-ball-ornament", "commercial-outdoor-fixtures", "commercial-recessed-fixtures", "commercial-strip-fixtures", "commercial-surface-fixtures", "commercial-wall-strip-fixtures", "ceiling-flush-mount", "ceiling-semi-flush", "chandelier", "desk-lamp", "exit-lights", "floor-lamps", "led-exit-lights", "mini-pendant", "outdoor-accessories", "outdoor-flush-mount", "outdoor-hanging-lights", "commercial-outdoor-fixtures", "outdoor-landscape", "outdoor-pathway", "outdoor-post-lights", "outdoor-utility-fixture", "outdoor-wall-fixture", "outdoor-wall-lantern", "pendant-lights", "table-lamps", "track-lighting", "vanity-lights", "wall-lights", "wall-sconce", "fixture-accessories", "high-bay-fixture", "under-cabinet-accessories", "fluorescent-under-cabinet", "led-under-cabinet", "xenon-under-cabinet", "access-panels", "cements", "cutting-oil", "primers-and-cleaners", "roof-flashings", "fuses", "cable-clips-and-staples-and-straps", "heat-shrink", "crimp-idc-and-quick-splice-connector", "pin-terminals", "alligator-clips", "batteries", "bushings", "cable-clamps-and-tie-mounts", "cable-glands", "cable-ties", "cat-5-cat-5e-cat-6", "chime", "chimes-bells-transformers-pushbuttons", "compression-connectors", "conduit-benders", "drill-bits", "drive-pins-and-power-loads", "electrical-tape", "emergency-exit-lighting", "emergency-lighting", "entrance-splicers", "fan-speed-controls", "fish-tapes", "flashlights", "floodlights", "generator-cords-and-connectors", "gloves", "grounding", "gwg-pvc-cements-and-roof-flashings", "hex-keys", "hole-plugs", "hole-saws", "home-network", "insulated-connectors", "insulation-piercing-connectors", "knives", "latching-duct", "liquid-tight-connectors", "luminaire-disconnects", "mechanical-connectors-aluminum", "mechanical-connectors-copper", "mechanical-lug-crimpers", "meter-socket-lugs", "meters-and-testers", "mini-terminals", "occupancy-sensors", "parallel-groove-connectors", "phone-coax-sound-plates", "photocontrols-and-light-sensor", "plastic-wallplates", "pliers", "porcelain-wireholders", "pullchain-and-keyless-receptacles", "push-in-wire-connectors", "pvc-entrance-cap", "reciprocating-saw-blades", "romex-connectors", "safety-glasses-and-safety-products", "safety-signs", "screwdrivers", "screws-and-fasteners-and-anchor-kits", "smoke-detector", "specialty-switches-and-pilot-lamps", "spiral-wrap-split-and-flex-tubing", "split-bolts", "splitters-and-f-connectors", "spring-steel-fittings", "stainless-steel-and-metal-wallplates", "strut-fittings", "surge-strips-and-extension-cords", "taps-and-adapters", "terminal-strips-and-blocks", "tool-bags-and-boxes", "vacancy-sensor", "vandal-resistant-fixtures", "wall-dimmers", "wall-receptacles", "wall-switches", "wall-timers", "wallpacks", "weatherproof-boxes-and-covers", "wire-connectors", "wire-lube", "wire-markers", "wire-strippers-cutters-crimpers", "worklights", "wrenches-and-hammers", "stage-accessories", "stage-cables", "stage-controllers", "dimmer-packs", "dj-clamps", "dj-light-stand", "ellipsoidals", "fog-fluid", "followspot", "gobos", "lighting-effects", "outdoor-led-lighting", "outdoor-lighting", "par-can-accessories", "par-cans-leds", "par16-can", "par16-cans-packages", "par36-pinspot", "par38-can", "par38-cans-packages", "par46-can", "par46-Ccans-packages", "par56-can", "par56-cans-packages", "par64-can", "par64-cans-packages", "ballast", "lamp-socket", "lamp-starter"],
      shape: ["2-in", "3-in", "4-in", "5-in", "6-in", "8-in", "a15", "a16", "a17", "a19", "a21", "a23", "alr12", "alr18", "ar111", "ar70", "a-shape", "b10", "b10.5", "b11", "b12", "b13", "b17", "b3-5", "b6", "b8", "b9-5", "ba11", "ba12", "ba9", "bd17", "br19", "br25", "br30", "br38", "br40", "bt14-5", "bt15", "bt28", "bt3", "bt37", "bt56", "bullet", "c11", "c15", "c6", "c7", "c9", "c9.5", "ca10", "ca5", "ca5.5", "ca7", "ca8", "ca9", "ca9-5", "cca10", "circline", "crank-up-truss-system", "crystallite", "c-t9", "double-tube-2-pin", "double-tube-4-pin", "double-ended", "e20-6", "ed120", "ed17", "ed18", "ed23", "ed23-5", "ed28", "ed37", "ed39", "ed55", "edx17", "ellipsoidal-e11", "ellipsoidal-e17", "ellipsoidal-e25", "er30", "er40", "et18", "et23.5", "f10", "f15", "festoon-type", "flame", "flame-twist", "flicker-flame", "globe", "globe-g11", "globe-g12-5", "globe-g13", "globe-g14", "globe-g16", "globe-g16-5", "globe-g17", "globe-g18-5", "globe-g19", "globe-g20", "globe-g21", "globe-g25", "globe-g3-5", "globe-g30", "globe-g4-5", "globe-g40", "globe-g6", "globe-g7", "globe-g8", "h-1", "h-2", "h-3", "hx10-5", "jdr", "k19", "mini-twist", "mr11", "mr13", "mr14", "mr16", "mr18", "mr8", "p25", "par14", "par16", "par20", "par30", "par30l", "par36", "par38", "par46", "par56", "par64", "pg17", "pr50", "prismlite", "ps25", "ps30", "ps35", "ps52", "quad-tube", "r111", "r12", "r14", "r16", "r25", "r30", "r37", "r40", "r56", "rectangular", "rp11", "s11", "s14", "s19", "s6", "s8", "single-tube-2-pin", "single-tube-4-pin", "t1", "t1-5", "t1-75", "t10", "t100", "t11", "t12", "t12-48-inch", "t12-72-inch", "t12-96-inch", "t13", "t14", "t15", "t17-60-inch", "t18", "t19", "t2", "t2.25", "t2-5", "t2-75", "t20", "t21", "t23", "t24", "t26", "t3", "t3-25", "t3-5", "t32", "t4", "t4-5", "t4-75", "t40", "t5", "t5--inch", "t5-6-inch", "t5-9-inch", "t6", "t6-5", "t7", "t7-5", "t8", "t8-12-inch", "t8-18-inch", "t8-24-inch", "t8-36-inch", "t8-48-inch", "t8-5", "t9", "t9-5", "tl", "tl3", "tl3-25", "torpedo", "triple-tube-2-pin", "triple-tube-4-pin", "triple-tube-e26-base", "tripod", "truss-system", "twist"],
      voltage: ["4v","6v", "10-8v", "12v", "13v", "14v", "14-5v", "15v", "17-4v", "22-8v", "24v", "28v", "30v", "33v", "36v", "80v", "82v", "85-5v", "86v", "100v", "115v", "120v", "130v", "125v", "208v", "220v", "225v", "230v", "240v"],
      base: ["1-inch-ribbon-leads", "10-spade", "1-inch-ribbon-leads", "10-spade", "2-contact-lugs", "2-pin-with-leads", "2-prong-plug", "2g10", "2g11", "2g7", "2gx13", "2gx7", "2-pin", "3-contact-lugs", "3-contact-mogul", "3-prong", "3-screw-terminals", "3-slip-on-terminals", "4-pin", "amp3", "axial-plastic", "axial-prefocus", "b22d-european-bayonet", "ba15d-double-contact-bayonet", "ba15s", "ba20d", "ba9s-miniature-bayonet", "bare-wire", "bay15d", "bi-pin", "by22d", "ceramic-cap-cable", "combination", "double-contact-prefocus", "double-end-axial", "double-end-disc", "e10-miniature-screw", "e11-mini-candelabra", "e12-candelabra-screw", "e14-european-intermediate-screw", "e17-intermediate-screw", "e26-medium-screw", "e26-medium-skirted", "e26d-3-contact-medium-screw", "e26lht-med-left-hand-thread", "e27-medium-screw", "e27-medium-skirt", "e39-mogul-screw", "e39d-3-contact-mogul-screw", "e40-export-mogul-screw", "e40-mogul-screw", "ep39-mogul-screw", "ex39-mogul-screw", "fa8-single-pin", "fax1-5", "fc2", "fc2-18-double-ended", "ferrule", "g10q", "g12-2-pin", "g13-2-pin", "g13-2-pin-medium-bi-pin", "g16d-2-contact-lugs", "g17q-7", "g17t-7-4-pin", "g22-medium-bipost", "g23", "g23-2", "g24d-1", "g24d-2", "g24d-3", "g24q-1", "g24q-2", "g24q-3", "g38-mogul-bi-post", "g4-2-pin", "g4.8-minature-bi-pin", "g5-2-pin", "g5-3-2-pin", "g5-348", "g6-2-pin", "g6-35-2-pin", "g7-9-2-pin-vented", "g8", "g8-5-2-pin", "g9-2-pin", "g9-5-2-pin", "g9-5-2-pin-w--heat-sink", "gr10q-4", "gry10q-3", "gu10", "gu10q", "gu24", "gu4-2-pin", "gu5-3-2-pin", "gu6-5","gu7", "gx10", "gx12-1", "gx16d-mogul-end-prong", "gx17q-7", "gx23", "gx23-2", "gx24d-2", "gx24d-3", "gx24q-1", "gx24q-2", "gx24q-3", "gx24q-4", "gx24q-5", "gx32d-2", "gx32d-3", "gx38", "gx5-3-2-pin", "gx51-mogul-bipost", "gx6-35-2-pin", "gx7-9-2-pin-vented", "gx8-5", "gx9-5-2-pin-prefocus", "gy16-2-pin", "gy22", "gy38", "gy5-3-2-pin", "gy6-35-2-pin", "gy6-5-2-pin", "gy8", "gy9-5-2-pin-prefocus", "gz4-miniature-2-pin", "gz6-35-2-pin", "gz9-5-2-pin-prefocus", "gzx4", "gzx9-5", "gzy9-5", "gzz9-5", "leads", "leads-w-female-flat-connectors", "leads-w-female-round-connectors", "leads-w-male-and-female-flat-connectors", "leads-w-male-flat-connectors", "m-23-bi-pin", "m4", "medium-np", "medium-side-prong", "miniature-bi-pin", "miniature-cap", "miniature-pinless", "mp2-screw-termnial", "p13-5s-single-contact-miniature-flanged", "p14-5s", "p15d25", "p15d30", "p20d", "p22d", "p25d", "p26-4t", "p28s-medium-prefocus", "p29t", "p30d", "p30s-single-contact-prefocus-base", "p32d2", "p40s-mogul-prefocus", "p43t-38", "p47d", "pg13-axial-plastic", "pg22", "pgj13-right-angle-prefocus", "pgj19-2", "pgj41", "pgj5", "pgjx28", "pgjx36", "pgjx50", "pgz12", "pgz18", "pgzx18", "pk22s", "pk30d-w-female-flat-connectors", "pk30d-w-male-flat-connectors", "plastic-wedge", "position-oriented-mogul", "printed-circuit-socket", "push-screw-terminal", "px26d", "px29t", "py20d", "qxl", "r17d-recessed-double-contact", "r7s-recessed-single-contact", "right-angle-prefocus", "rigid-loop", "rx7s-rsc", "s14s", "s25.5", "s30", "s5-7s9-midget-grooved", "screw-terminal-g53", "sf6-de-cap", "sfa21", "sfa27-11", "sfa6-2", "sfa7-5-2", "sfa9-2", "sfc", "sfc10-4", "sfc15-5", "sfc15-5-6", "sfcx12-4", "sleeve", "slip-on-terminals", "sot2-slip-on-terminals", "spec", "special", "straight", "sv8.5-8-festoon", "sx4s4-sub-midget-flanged", "sx6s-midget-flanged", "tab", "ts3-telephone-slide", "ts5-telephone-slide", "w2-1x4-9d-sub-mini-wedge", "w2-1x9-5d-mini-wedge", "w2-5x16d", "w3x16q-plastic-wedge", "wedge", "wire-lead", "wire-terminals", "x511", "x514"],
      beamspread: ["flood-fl", "medium-flood-mfl", "narrow-flood-nfl", "narrow-spot-nsp", "spot-sp", "super-spot-ssp", "very-narrow-spot-vnsp", "very-wide-flood-vwfl", "wide-flood-wfl", "wide-spot-wsp"],
      color: ["1800k", "1900k", "1950k", "2000k", "2100k", "2150k", "2200k", "2400k", "2500k", "2700k-5500k", "2550k", "2600k", "2650k", "2675k", "2680k", "2700k", "2710k", "2720k", "2725k", "2730k", "2750k", "2760k", "2770k", "2775k", "2780k", "2790k", "2800k", "2810k", "2815k", "2825k", "2830k", "2840k", "2850k", "2860k", "2870k", "2875k", "2880k", "2900k", "2916k", "2925k", "2950k", "3000k", "3025k", "3050k", "3065k", "3075k", "3100k", "3125k", "3138k", "3150k", "3200k", "3225k", "3250k", "3265k", "3300k", "3000-3300k", "3350k", "3400k", "3450k", "3500k", "3540k", "3560k", "3600k", "3000-3600k", "3700k", "3800k", "3900k", "4000k", "4050k", "4100k", "4200k", "4300k", "4400k", "4500k", "4700k", "4800k", "5000k", "5200k", "5300k", "5400k", "5400k", "5500k", "5600k", "5700k", "5800k", "5900k", "6000k", "5500-6000k", "6050k", "6200k", "6500k", "6700k", "6900k", "7000k", "7200k", "7400k", "7500k", "7800k", "8000k", "8500k", "8600k", "9325k", "10000k", "10000k", "14000k", "20000k", "warm-white", "soft-white", "white", "cool-white", "daylight", "amber", "antique-gold", "aqua", "aquamarine", "azure", "baby-blue", "beige", "black", "blue", "blue-green", "blue-violet", "blue-green", "bronze", "brown", "brushed-nickel", "brown-green", "burgundy", "burnt-orange", "burnt-sienna", "burnt-umber", "champagne", "charcoal", "chartreuse", "cherry-blossom-pink", "chocolate", "cobalt", "copper", "coral", "cream", "crystal-white", "cyan", "dandelion", "emerald", "flocked-pink-on-pink", "forest-green", "french-rose", "fuchsia", "gold", "green", "grey", "hot-pink", "indigo", "ivory", "lavender", "lemon", "lilac", "lime", "lime-green", "linen", "magenta", "maroon", "mint-green", "misty-rose", "mocha", "multi-color", "mustard", "navy-blue", "ochre", "olive", "orange", "orchid", "peach", "pink", "platinum", "pumpkin", "purple", "red", "red-black", "rgb", "rgb-color-mixing", "rose", "royal-blue", "roy-purple", "salmon", "sangria", "sapphire", "scarlet", "sepia", "silver", "sky-blue", "sparkle-white", "tan", "tangerine", "teal", "turquoise", "violet", "yellow"],
      brand: ["3D-Perception", "3M", "Acclaim-Lighting", "Acer", "Akai", "American-DJ", "American-Lighting", "Anders-and-Kern", "Apollo", "Apollo-Gobos", "Ask", "Barco", "BenQ", "BoxLight", "Bulbamerica", "Bulbrite", "Canon", "Casio", "Chauvet", "Chisholm", "Christie", "Cinego", "Classic-Antique-Bulb-co.", "Dell", "Digital-Projection", "Diode-LED", "Dream-Vision", "Dukane", "DWIN", "Eiki", "EIKO", "Elation-Professional", "Eliminator", "Elmo", "Epson", "ETC", "Everest", "FEIT-Electric", "Fujitsu", "Gateway", "GE", "Geha", "Geha-Projection", "Gemstar", "GreenLite", "Griven", "Hewlett-Packard-HP", "Hitachi", "Holiday-Essence", "IBM", "Infocus", "InstaLite", "JVC", "Knoll", "Knoll-Systems", "Kobi-Electric", "Kodak", "Kringle-Traditions", "Legend", "LG", "Liesegang", "Lightronics", "Lithonia", "Loewe-Articos", "Luxrite", "Luxtel", "Marantz", "Metavision", "Miracle-LED", "Mitsubishi", "Morris", "NEC", "NeoLite-Litetronics", "Nicor", "Nobo", "Nuvo-Lighting", "Olympus", "Optima-Lighting", "Optoma", "Osram-Sylvania", "Panasonic", "Philips", "Phoenix", "Pioneer", "Planar", "Platinum", "Plus", "Polaroid", "ProjectionDesign", "Projector-Europe", "Proxima", "RCA", "Runco", "Sagem", "Sahara", "Samsung", "Sanyo", "Satco", "Sharp", "Sim2", "SmartBoard", "Sony", "Soraa", "Specialty-Equipment", "Stage-Light", "Sunlite", "Taxan", "Telex", "Times-Square-Lighting", "Toshiba", "Trisonic", "Ushio", "Verilux", "Vickerman", "Vidikron", "Viewsonic", "Viore", "Visual-Effects-IND", "Vivitek", "Vizio", "Wintergreen-Lighting", "Xenon", "Yamaha", "Yokogawa", "Zenith"],
      cabletype: ["uncovered", "silicone-cover", "waterproof"],
      ledchipsize: ["3528-smd", "5050smd", "5050-smd"],
      price: ["under-10", "10-to-20", "20-to-30", "30-to-40", "40-to-50", "50-to-75", "75-to-100", "100-to-150", "150-to-300", "300-to-500", "over-500"],
      wattage: ["under-3w", "3w-6w", "6-1w-9-9w", "10w-15w", "16w-20w", "21w-30w", "31w-40w", "41w-60w", "61w-80w", "81w-100w", "101w-150w", "151w-300w", "301w-500w", "501w-1000w", "Over-1000w"],
      luminusflux: ["under-300lm", "300-450lm", "451-800lm", "801-1100lm", "1101-1600lm", "1601-2600lm", "over-2600lm"],
      incandescentequivalent: ["5w-equiv", "10w-equiv", "15w-equiv", "20w-equiv", "25w-equiv", "30w-equiv", "35w-equiv", "40w-equiv", "50w-equiv", "60w-equiv", "65w-equiv", "70w-equiv", "75w-equiv", "80w-equiv", "90w-equiv", "100w-equiv", "120w-equiv", "150w-equiv", "200w-equiv", "250w-equiv", "300w-equiv", "350w-equiv", "400w-equiv"],
	  needlematerial: ["classic-pvc-trees", "classic-pvc", "ultra-realistic", "ultra-realistic-trees"],
	  height: ["2-ft", "2-5-ft", "3-ft", "3-5-ft", "4-ft", "4-5-ft", "5-ft", "5-5-ft", "6-ft", "6-5-ft", "7-ft", "7-5-ft", "8-ft", "8-5-ft", "9-ft", "9-5-ft", "10-ft", "12-in-", "12-ft", "14-ft", "14-in-", "15-ft", "16-in-", "16-5-ft", "18-in-", "20-in-", "20-ft", "23-5-ft", "24-in-", "27-ft", "30-in-", "30-5-ft", "34-ft", "36-in-", "37-5-ft", "41-ft", "42-in-", "44-5-ft", "48-in-", "60-in-", "72-in-", "84-in-", "96-in-", "100-in-", "120-in-", "144-in-", "300-in-"],
      lighttype: ["wide-angle-led", "unlit", "mini-and-g50-lights", "mini-lights", "m5-mini-led", "led", "c7-led", "dura-lit"],
      numberoflights: ["20-bulbs", "25-bulbs", "30-bulbs", "35-bulbs", "50-bulbs", "65-bulbs", "70-bulbs", "80-bulbs", "100-bulbs", "110-bulbs", "150-bulbs", "165-bulbs", "200-bulbs", "234-bulbs", "240-bulbs", "250-bulbs", "300-bulbs", "350-bulbs", "360-bulbs", "400-bulbs", "450-bulbs", "480-bulbs", "500-bulbs", "525-bulbs", "550-bulbs", "600-bulbs", "605-bulbs", "650-bulbs", "680-bulbs", "700-bulbs", "720-bulbs", "722-bulbs", "750-bulbs", "794-bulbs", "800-bulbs", "850-bulbs", "880-bulbs", "900-bulbs", "948-bulbs", "950-bulbs", "960-bulbs", "990-bulbs", "1000-bulbs", "1050-bulbs", "1100-bulbs", "1110-bulbs", "1150-bulbs", "1200-bulbs", "1216-bulbs", "1238-bulbs", "1250-bulbs", "1300-bulbs", "1350-bulbs", "1400-bulbs", "1440-bulbs", "1450-bulbs", "1500-bulbs", "1545-bulbs", "1600-bulbs", "1634-bulbs", "1650-bulbs", "1798-bulbs", "1800-bulbs", "1850-bulbs", "1900-bulbs", "2000-bulbs", "2040-bulbs", "2050-bulbs", "2100-bulbs", "2150-bulbs", "2200-bulbs", "2250-bulbs", "2260-bulbs", "2326-bulbs", "2450-bulbs", "2500-bulbs", "2550-bulbs", "2600-bulbs", "2610-bulbs", "2650-bulbs", "2700-bulbs", "2800-bulbs", "2850-bulbs", "2980-bulbs", "3050-bulbs", "3240-bulbs", "3270-bulbs", "3500-bulbs", "3600-bulbs", "3850-bulbs", "3950-bulbs", "4035-bulbs", "5910-bulbs"]};

 $scope.tagFilter = function(results, label) {
  var currentlyAllowed = $scope.allowedFacets[label];

  var result = [];
  angular.forEach(results, function(facet, idx) {    
    if (currentlyAllowed.indexOf(facet.value) >= 0) {
      result.push(facet);
    }
  });

  result.sort(function(a, b) {
    return currentlyAllowed.indexOf(a.value)-currentlyAllowed.indexOf(b.value);
  });

  return result;
 };

  $scope.clearAllLink = function(){
    $scope.queryFilters = { shopify: {} };

  };

  $scope.clearAllFacetLink = function(label){
    var clearList = $scope.allowedFacets[label];
    var currentList = $scope.queryFilters['shopify']['tags']["values"];

    for (var i=clearList.length-1; i>=0; i--) {
      var tag = clearList[i];
      if (currentList.indexOf(tag) >= 0) {
        var index = currentList.indexOf(tag);
        currentList.splice(index, 1);
      }
    }

    $scope.queryFilters['shopify']['tags']["values"] = currentList;
  };
  
  $scope.quickView = function(id) {
    $.magnificPopup.open({ items: { src: '#prod-' + id , type: 'inline' } });
  };

  $scope.sortingOptions = [
    {label: 'Sort by relevance', field: '_score' , direction: 'desc' },
    {label: 'Sort by newest', field: 'published_at' , direction: 'desc' },
    {label: 'Sort by price: low to high', field: 'variant_price' , direction: 'asc' },
    {label: "Sort by price: high to low", field: "variant_price", direction: "desc" }
  ];
  $scope.querySort = $scope.sortingOptions[0];

  // Result state
  $scope.searchResults = [];
  $scope.resultFacets = {};
  $scope.resultSummary = {};
  $scope.currentPage = 1;
  $scope.totalPages = {};
  $scope.totalResultCount = {};
  $scope.pages = {};

  // Display state
  $scope.visibleDocType = $scope.docTypes[0];

  $scope.$watch(function() {
    return JSON.stringify([
      $scope.resultFacets
    ]);
  }, function() {
    $scope.saveCurrentState();
    $scope.setQueryFilters();
  });

  $scope.$watch(function() {
    return JSON.stringify([
      $scope.currentPage
    ]);
  }, function() {
    $scope.saveCurrentState();
    $scope.executeSearch();
  });

  $scope.$watch(function() {
    return JSON.stringify([
      $scope.querySort,
      $scope.queryPerPage,
      $scope.queryFacets,
      $scope.queryFilters
    ]);
  }, function() {
    $scope.saveCurrentState();
    $scope.executeSearch();
  });

  $scope.executeNewSearch = function(query) {
    if(typeof query !== 'undefined') {
      $scope.stq = query;
    }
    $scope.currentPage = 1;
    $scope.executeSearch();
  }

  $scope.executeSearch = function() {

    var sortField = {};
    var sortDirection = {};
    angular.forEach($scope.docTypes, function(docType, idx) {
      sortField[docType] = $scope.querySort.field;
      sortDirection[docType] = $scope.querySort.direction;
    });

    if ($scope.redirects[$scope.stq]) {
      window.location = $scope.redirects[$scope.stq];
    }

    swiftypePublicApi.search($scope.stq, {
      sort_field: sortField,
      sort_direction: sortDirection,
      facets: $scope.queryFacets,
      filters: $scope.queryFilters,
      per_page: $scope.queryPerPage,
      spelling: 'always',
      page: $scope.currentPage
    }).success(function(data, status, header) {
      $scope.searchResults = data.records;
      $scope.setResultSummary(data.info);
      // $scope.setSpellingCorrection(data.info.articles);
      $scope.setResultFacets(data.info);
    });
  };
  

  $scope.activatedFacet = function(docType, fieldName) {
    var active = false;
    angular.forEach($scope.resultFacets[docType][fieldName], function(facet, idx) {
      if(facet.active) {
        active = true;
      }
    });
    return active;
  }

  $scope.clearFacet = function(docType, fieldName) {
    angular.forEach($scope.resultFacets[docType][fieldName], function(facet, idx) {
      facet.active = false;
    });
  }

  var numberWithCommas = function(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  // Used when results can be one (string) or many (array) and we just want to show something.
  $scope.getOrFirst = function(result, key) {
    if(result[key] instanceof Array) {
      return result[key][0];
    } else {
      return result[key];
    }
  };

  $scope.formatPrice = function(price) {
    if (price) {
      return numberWithCommas(price.toFixed(2));
    } else {
      return numberWithCommas(0);
    }
  };


  $scope.publicationDate = function(published_at) {
    var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var date = new Date(published_at);
    return monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
  }

  $scope.snippet = function(result) {
    var bodyText = (typeof result.body === 'object') ? result.body[0].substring(0,300) : result.body.substring(0,300);
    return result.highlight.body || bodyText;
  }

  $scope.viewProduct = function(url) {
    document.location = url;
  };

  $scope.facetFieldNames = function(fieldName) {
    var facetFieldNames = {
      'author': 'Author',
      'top_category': 'Category',
      'category': 'Category'
    }
    return facetFieldNames[fieldName];
  };

  $scope.getTitle = function(result) {
    //console.log(result);
    var title = result.highlight.title || result.title;
    //console.log(title.split("|",1)[0]);
    return title.split("|",1)[0];
  }


  $scope.setQueryFilters = function() {
    var activeFilters = {};

    angular.forEach($scope.docTypes, function(docType, idx) {
      if ($scope.urlFilters) {
        activeFilters[docType] = $scope.urlFilters[docType];
        $scope.urlFilters = undefined;
      } else {
        activeFilters[docType] = {};
      }
      
      angular.forEach($scope.resultFacets[docType], function(facetList, fieldName) {
        activeFilters[docType][fieldName] = { type: "and", values: [] };
        angular.forEach(facetList, function(facet) {
          if (facet.active) {
            activeFilters[docType][fieldName]["values"].push(facet.value);
          }
        });
      });
    });
    

    // for each filter, check if query contains it. If so, add to the filters.
    // console.log(s.indexOf("oo") > -1);
    var tags = [];
    angular.forEach($scope.allowedFacets['type'], function(term, idx){
      vanityTerm = term.replace('-', ' ');
      vanityTerm = vanityTerm.substring(0, vanityTerm.length - 1);

      if ($scope.stq.indexOf(vanityTerm) > -1) {
        tags.push(term);
      }
    });

    if (tags.length > 0){
      if (activeFilters['shopify']['tags']['type']){
        activeFilters['shopify']['tags']['values'] = activeFilters['shopify']['tags']['values'].concat(tags);
      } else {
        activeFilters['shopify']['tags'] = { type: "and", values: tags };
      }
    }

    $scope.queryFilters = activeFilters;
  };

  $scope.isFilterActive = function(docType, fieldName, fieldValue) {
    var filters = $scope.queryFilters[docType][fieldName];
    if (typeof filters !== 'object') {
      return false;
    }
    return filters["values"].indexOf(fieldValue) !== -1;
  };

  $scope.setSpellingCorrection = function(info) {
    if(info.spelling_suggestion) {
      $scope.spellingCorrection = info.spelling_suggestion.text;
    } else {
      $scope.spellingCorrection = null;
    }

  }

  $scope.numberWithCommas = function(number) {
    if(typeof number !== 'undefined') {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return '';
  }

  $scope.setResultSummary = function(resultInfo) {
    angular.forEach(resultInfo, function(info, docType) {
      if(info.total_result_count > 0) {
        var first = (info.current_page-1)*info.per_page + 1;
        var last = (info.current_page)*info.per_page;
        var totalPages = Math.ceil(info.total_result_count / $scope.queryPerPage);
        $scope.totalResultCount[docType] = info.total_result_count;
        $scope.resultSummary[docType] = "Showing results " + first + "-" + last + " of " + $scope.numberWithCommas(info.total_result_count) + " for";
        $scope.totalPages[docType] = Math.min(totalPages, 50);
      } else {
        $scope.totalResultCount[docType] = 0;
        $scope.resultSummary[docType] = "Sorry, no results were found for";
        $scope.totalPages[docType] = 0;
      }

      $scope.pages[docType] = [];
      for(var i = 1; i <= $scope.totalPages[docType]; i++) {
        $scope.pages[docType].push(i);
      }

    });

  }

  $scope.setResultFacets = function(resultInfo) {
    angular.forEach(resultInfo, function(info, docType) {
      $scope.resultFacets[docType] = {};
      angular.forEach(info.facets, function(facetData, fieldName) {
        $scope.resultFacets[docType][fieldName] = [];
        angular.forEach(facetData, function(count, fieldValue) {
          if(fieldValue.length > 0) {
            $scope.resultFacets[docType][fieldName].push({
              value: fieldValue,
              count: count,
              active: $scope.isFilterActive(docType, fieldName, fieldValue)
            });
          }
        });
      });
    });


  };
   
  $scope.checkProductQty = function(event, variantId, productName, productInventory) {
  var cannotAddThisQuantity = false,
      message = 'We do not have %q item of '+ productName +' left.',
      selectedVariantId = variantId,
      quantityToAdd = parseInt(jQuery("#product-quantity-"+variantId).val()) || 1,
      quantityInCart = 0,
      title = '',
      inventoryLimited = true,
      inventory = productInventory;
  
  if (inventoryLimited) {
    if (inventory < quantityToAdd) {
      message = message.replace('%q', quantityToAdd);
      if (quantityToAdd > 1) message.replace('item', 'items');
      cannotAddThisQuantity = true;
    } 
  }
  if (cannotAddThisQuantity) {
    alert(message);
    event.preventDefault();
    return false;
  }
  else {
    return true;
  }
  };
  
}]);

searchApp.config(function(swiftypePublicApiProvider) {
  swiftypePublicApiProvider.setEngineKey('jZrtwySzKXz_sxYVDbsd');
});
